var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.705 6.992c.01-.148.022-.296.022-.447A6.546 6.546 0 0 0 14.182 0a6.542 6.542 0 0 0-5.793 3.503 3.802 3.802 0 0 0-1.298-.23A3.818 3.818 0 0 0 3.358 7.89a4.91 4.91 0 0 0 1.551 9.565h4.91a.545.545 0 1 0 0-1.091h-4.91a3.823 3.823 0 0 1-3.818-3.819c0-1.645 1.05-3.099 2.612-3.62l.925-.308-.203-.954a2.73 2.73 0 0 1 2.666-3.3c.31 0 .622.056.926.166l.894.324.442-.841a5.445 5.445 0 0 1 4.829-2.921 5.46 5.46 0 0 1 5.454 5.454c0 .095-.007.189-.013.282l-.007.094-.05.767.706.305a4.362 4.362 0 0 1-1.727 8.37h-4.363a.545.545 0 1 0 0 1.092h4.363a5.455 5.455 0 0 0 2.16-10.463m-5.432 12.644a.546.546 0 0 0-.386.16l-2.342 2.342V9.273a.545.545 0 1 0-1.09 0v12.865l-2.342-2.342a.544.544 0 0 0-.931.386c0 .15.06.287.16.385l3.272 3.273a.545.545 0 0 0 .772 0l3.272-3.273a.545.545 0 0 0-.386-.931",
    fill: "#222220",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdfIcon);
export default __webpack_public_path__ + "static/media/download-pdf-icon.4206f1f8.svg";
export { ForwardRef as ReactComponent };